import { useEffect, useState } from "react";
import {
  Routes,
  Route,
  NavLink,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TimelineIcon from "@mui/icons-material/Timeline";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DescriptionIcon from "@mui/icons-material/Description";
import axiosInstance from "../../../Config/axiosInstance";
import ClientPortfolioOverview from "./ClientPortfolioOverview";
import ClientPortfolioTimeline from "./ClientPortfolioTimeline";
import ClientPortfolioContracts from "./ClientPortfolioContracts";
import ClientPortfolioAnafQuery from "./ClientPortfolioAnafQuery";
import ClientPortfolioContacts from "./ClientPortfolioContacts";

import "./ClientPortfolioView.css";

function ClientPortfolioView() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [clientData, setClientData] = useState(location.state?.client || null);
  const [loading, setLoading] = useState(!location.state?.client);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchClientDetails = async () => {
      if (clientData) return;

      try {
        setLoading(true);
        setError("");

        const res = await axiosInstance.get("/client-portfolio/");
        const foundClient = (res.data || []).find(
          (item) => String(item.id) === String(id)
        );

        if (!foundClient) {
          setError("Clientul nu a fost găsit.");
          return;
        }

        setClientData({
          id: foundClient.id,
          client_code: foundClient.client_code || "-",
          cui: foundClient.cui || "-",
          name: foundClient.name || "-",
          total_contracts_value: foundClient.total_contracts_value ?? 0,
          total_contracts_system: foundClient.total_contracts_system ?? 0,
          percentage: foundClient.percentage ?? 0,
          status: foundClient.status || "-",
        });
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "A apărut o eroare la încărcarea datelor."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchClientDetails();
  }, [id, clientData]);

  if (loading) {
    return (
      <div className="client-portfolio-view-page">
        <div className="client-portfolio-shell">
          <div className="loading-shimmer">
            <div className="shimmer-header"></div>
            <div className="shimmer-content"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="client-portfolio-view-page">
        <div className="client-portfolio-shell">
          <div className="client-header-minimal">
            <div className="client-title-row">
              <button
                type="button"
                className="back-button-inline minimal-back"
                onClick={() => navigate("/client-portfolio")}
                aria-label="Înapoi"
                title="Înapoi"
              >
                <ArrowBackIcon fontSize="medium" />
              </button>

              <h1 className="client-main-title">CLIENT PORTFOLIO DETAILS</h1>
            </div>

            <div className="client-header-sub error-text">{error}</div>

            <div className="client-header-divider"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="client-portfolio-view-page">
      <div className="client-portfolio-shell">
        <div className="client-header-minimal">
          <div className="client-title-row">
            <button
              type="button"
              className="back-button-inline minimal-back"
              onClick={() => navigate("/client-portfolio")}
              aria-label="Înapoi"
              title="Înapoi"
            >
              <ArrowBackIcon fontSize="medium" />
            </button>

            <div className="client-title-block">
              <h1 className="client-main-title">{clientData.name}</h1>

              <div className="client-header-sub">
                <span>CUI: {clientData.cui}</span>
                <span className="dot">·</span>
                <span>Cod client: {clientData.client_code}</span>
              </div>
            </div>
          </div>

          <div className="client-header-divider"></div>
        </div>

        <div className="client-tabs-row">
          <NavLink
            to={`/client-portfolio-view/${id}/overview`}
            className={({ isActive }) =>
              `client-tab-button ${isActive ? "active" : ""}`
            }
          >
            <QueryStatsIcon fontSize="small" />
            <span>Overview</span>
          </NavLink>

          <NavLink
            to={`/client-portfolio-view/${id}/timeline`}
            className={({ isActive }) =>
              `client-tab-button ${isActive ? "active" : ""}`
            }
          >
            <TimelineIcon fontSize="small" />
            <span>Timeline</span>
          </NavLink>

          <NavLink
            to={`/client-portfolio-view/${id}/contracts`}
            className={({ isActive }) =>
              `client-tab-button ${isActive ? "active" : ""}`
            }
          >
            <DescriptionIcon fontSize="small" />
            <span>Contracts & Opportunities</span>
          </NavLink>

          <NavLink
            to={`/client-portfolio-view/${id}/anaf-query`}
            className={({ isActive }) =>
              `client-tab-button ${isActive ? "active" : ""}`
            }
          >
            <QueryStatsIcon fontSize="small" />
            <span>Anaf Query</span>
          </NavLink>

          <NavLink
            to={`/client-portfolio-view/${id}/contacts`}
            className={({ isActive }) =>
              `client-tab-button ${isActive ? "active" : ""}`
            }
          >
            <ContactMailIcon fontSize="small" />
            <span>Contacts</span>
          </NavLink>
        </div>

        <div className="client-tab-content">
          <Routes>
            <Route index element={<Navigate to="overview" replace />} />
            <Route
              path="overview"
              element={<ClientPortfolioOverview clientData={clientData} />}
            />
            <Route
              path="timeline"
              element={<ClientPortfolioTimeline clientData={clientData} />}
            />
            <Route
              path="contracts"
              element={<ClientPortfolioContracts clientData={clientData} />}
            />
            <Route
              path="anaf-query"
              element={<ClientPortfolioAnafQuery clientData={clientData} />}
            />
            <Route
              path="contacts"
              element={<ClientPortfolioContacts clientData={clientData} />}
            />
            <Route path="*" element={<Navigate to="overview" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default ClientPortfolioView;